module.exports = __webpack_public_path__ + "img/11.5350a9c4.png";